<template>
  <HeroQuickLinksButton
    v-editable="blok"
    :icon="blok.icon as Icon"
    :label="blok.label"
    @click="onClick"
  />
</template>

<script setup lang="ts">
import type { Icon } from '@/components/ui/UiIcon.vue'
import type { BlockHeroQuickLinksMenuAnchorStoryblok } from '@/types/storyblok'

const props = defineProps<{ blok: BlockHeroQuickLinksMenuAnchorStoryblok }>()

function onClick(event: Event): void {
  event.preventDefault()

  const element = document.getElementById(props.blok.anchor)

  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>
